<template>
    <v-container v-if="opened" fluid :style="{backgroundColor, height, padding}" :class="className">
        <v-container :style="{height, padding}">
            <v-layout justify-end align-center :style="{height}">
                <slot/>
                <v-btn @click="closeAndSave()" icon>
                    <v-icon :color="iconColor">$vuetify.icons.close</v-icon>
                </v-btn>
            </v-layout>
        </v-container>
    </v-container>
</template>

<script>
export default {
    props: [
        'backgroundColor',
        'height',
        'padding',
        'className',
        'iconColor',
    ],
    data() {
        return {
            opened: true,
        };
    },
    mounted() {
        if (this.$session.exists('showInfoBar') === true) {
            this.opened = this.$session.get('showInfoBar');
        }
    },
    methods: {
        closeAndSave() {
            this.$session.set('showInfoBar', false);
            this.opened = false;
        },
    },
};
</script>